import { createSlice } from "@reduxjs/toolkit";
import * as action from "../actions/usersActions";

export const usersSlicer = createSlice({
  name: "users",
  initialState: {
    newUsers: null,
    loading: false,
    errors: null,
  },
  extraReducers: {
    [action.getNewUsers.pending]: (state) => {
      state.loading = true;
    },
    [action.getNewUsers.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.newUsers = data;
      } else {
        state.errors = data.errors;
      }
      state.loading = false;
    },
  },
});

export default usersSlicer.reducer;
